module.exports = __webpack_public_path__ + "images/favicon-1d1581852f3f1201b92ea92ca22a0fb4.ico";